import i18n from 'i18next'


import { initReactI18next } from 'react-i18next'
import { language as enLocale } from './en-US';
import { language as brLocale } from './pt-BR';
import LanguageDetector from 'i18next-browser-languagedetector';
const resources = {
    
    'en-US':{
        translations:{
            ...enLocale
        }
    },
    'en':{
        translations:{
            ...enLocale
        }
    },
    'pt-BR':{
        translations:{
            ...brLocale
        }
    }
} 

const detector ={
  name: 'myDetectorsName',

  lookup(options: any) {
    // options -> are passed in options
    console.log('options', options)
    return 'en';
  },

  cacheUserLanguage(lng : any, options: any) {
    console.log('lng', lng)
    console.log('options', options)
    // options -> are passed in options
    // lng -> current language, will be called after init and on changeLanguage
    // store it
  },
};

const languageDetector = new LanguageDetector();
languageDetector.addDetector(detector);



i18n
    .use(initReactI18next)
    .use(languageDetector) 
    .init({
        fallbackLng:'pt-BR',
        debug: true,
        resources,
        defaultNS: 'translations',
        ns: ['translations'],
        interpolation:{
            escapeValue: false,
            formatSeparator: '.'
        }
    });

    export default i18n;
